// extracted by mini-css-extract-plugin
export default {"rootLoading":"FullPageLoading_rootLoading__rfVrn"};